<template>
  <div class="listPage">
    <div class="banner">
      <img src="../../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">商务&销售管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">退款申请审核</div>
    </div>

    <div class="input_box flex-between">
      <van-field
        v-model="params.keyword"
        placeholder="输入关键字查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <i class="iconfont icon-sousuo" @click="handleSearch"></i>
    </div>

    <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="row_one mb">
            <p>退款工单号：{{ item.workno }}</p>
            <p>订单编号：{{ item.orderno }}</p>
            <p>创建时间：{{ item.createdate | formatDate }}</p>
            <p>账户姓名：{{ item.truename }}</p>
            
            <!-- <p>账户id：{{ item.accountid }}</p>
            <p>用户手机号：{{ item.mobile }}</p> -->
          </div>

          <div class="row_one mb">
            <p>物流类型：{{ item.service_companystr }}</p>
            <p>发货物流单号：{{ item.service_no }}</p>
            <p>退款类型：{{ item.logtypestr }}</p>
            <p>退款金额：{{ item.fee }}</p>
          </div>

          <div class="row_one mb">
            <p>退款情况：{{ item.returnnotestr }}</p>
            <p>退款属性：{{ item.returnattrstr }}</p>
            <p>退费原因：{{ item.reasonidstr }}</p>
            <p>退款状态：{{ item.returnstate }}</p>
            <p>
              退款审核状态：{{
                item.checkstatestr}}
            </p>
            <p>退款金额：{{ item.fee }}</p>
          </div>

          <div class="row_one mb">
            <!-- <p>是否取消退款：{{ item.iscancel == 1 ? "是" : "否" }}</p> -->
            
            <p>退款时间：{{ item.returndate | formatDate }}</p>
            <p>备注：{{ item.talk }}</p>
          </div>
        </div>
      </template>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无申请记录"
      />
    </div>
    <!-- <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回业务中心
    </div> -->

    <div class="fixd_button_btm" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import {encryptstringadd} from '../../../api/api'
import { getBacklogList } from "../../../api/shop";
// import { calculator } from "../../../utils/decimal";
// import Tabbar from "../../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "cBacklogList",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      qyid: "",

      select: "全部",
      dataList: [],
      type: "",
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        checkstate: '',
        qyguid: ''
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.type = this.$route.params.type;
    let { USERINFO } = this.$store.state;
    if (USERINFO.qy) {
      this.params.qyguid = USERINFO.qy.qyguid;
    } else {
      this.params.qyguid = 0;
    }
  },
  mounted() {
    this.getBacklogList(); // 初始化加载数据
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 搜索
    handleSearch() {
      this.getBacklogList();
    },

    getBacklogList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getBacklogList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getBacklogList();
      }
    },
    handleDetail(id) {
      // this.$router.push(`/comSalesIndex/cBacklogDetail/${id}`);
      this.encryptstringadd('cBacklogDetail', {id})
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.listPage {
  padding-bottom: 300px;
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    flex-wrap: wrap;
    margin: 70px 70px 60px;
    .item {
      border: 1px solid #d2d2d2;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 19px;
      margin-right: 10px;
      margin-bottom: 20px;
      span {
        width: 40px;
        display: inline-block;
        margin-left: 20px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .order_wrap {
    margin-top: 40px;
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;
        &.mb {
          margin-bottom: 30px;
        }
        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 30px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            // &:last-child {
            //   font-size: 30px;
            // }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        .red {
          color: #ee0032;
        }
      }
    }
  }
}
</style>